<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-checkerboard</v-icon>{{$t('profile.printingsurface.thickness')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <PrintingSurfaceThicknessForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import PrintingSurfaceThicknessForm from '../../components/printingsurfacethickness/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'PrintingSurfaceThickness';

const { mapFields } = createHelpers({
  getterType: 'printingsurfacethickness/getField',
  mutationType: 'printingsurfacethickness/updateField'
});

export default {
  name: 'PrintingSurfaceThicknessCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    PrintingSurfaceThicknessForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('printingsurfacethickness', ['create', 'reset'])
  }
};
</script>
